import Vue from "vue";
import Vuetify from "vuetify/lib";
import fa from "vuetify/lib/locale/fa";

Vue.use(Vuetify);

export default new Vuetify({
  /*  breakpoint: {
        thresholds: {
            xs: 340,
            sm: 540,
            md: 800,
            lg: 1280,
        },},*/
    icons: {
        iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
    lang: {
        locales: { fa },
        current: "fa",
        rtl: {
            fa: true,
        },
    },

    rtl: true,
    theme: {
        themes: {
            light: {
                primary: "#313c42",
                secondary: "#f6f4f7",
                third: "#72B9F9",
                lightBlue: "#796EFF",
                darkBlue: "#035BAB",
                grayColor: "#F5F6FD",
                warning: "#0088CC",
            },
        },
    },
});
